// extracted by mini-css-extract-plugin
module.exports = {"fields":"_2KiHtrCpl0QAoA2SwV8s98","row":"_1zywk85irhFBEysWw1jghs","divider":"nDmNpYelBg50cbTAHikMV","flex1":"_1PoQeK9dMR-50ewmEyf0ss"};